<template>
  <div class="base-popup">
    <div
      class="base-popup__backdrop"
      aria-hidden
      @click="handleBackdropClick"
    />
    <div class="base-popup__slot">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  close: [];
}>();

const handleBackdropClick = (): void => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.base-popup {
  position: fixed;
  inset: 0;
  z-index: $z-backdrop;
  display: flex;
  align-items: center;
  justify-content: center;

  &__backdrop {
    position: absolute;
    inset: 0;
    background-color: rgba($color-black-backdrop, 0.9);
    backdrop-filter: blur(4px);
  }

  &__slot {
    position: relative;
    z-index: $z-modal;
  }
}
</style>
